import { useAtomValue } from 'jotai';
import { upsertUserConfigAtom } from '@/atoms/mutations/userConfigs/userConfigs';
import { userConfigsAtom } from '@/atoms/queries/userConfigs';
import { UserConfigPutMutationParams } from '@/types/userConfigs';

export const useUpsertUserConfig = (options: { shouldRefetch: boolean } = { shouldRefetch: true }) => {
  const userConfigs = useAtomValue(userConfigsAtom);
  const { mutateAsync: upsertUserConfig } = useAtomValue(upsertUserConfigAtom);

  const handleUpsertUserConfig = async (...mutationParams: UserConfigPutMutationParams[]) => {
    const { configIds, isSuccess } = await upsertUserConfig(mutationParams);
    if (options.shouldRefetch && isSuccess) {
      await userConfigs.refetch();
    }
    return { configIds, isSuccess };
  };

  return handleUpsertUserConfig;
};
